#viewport width and height, correct values
window.viewport = ->
	e = window
	a = 'inner'
	if !('innerWidth' of window)
		a = 'client'
		e = document.documentElement or document.body
	{
		width: e[a + 'Width']
		height: e[a + 'Height']
	}
	
window.isMobile = ->
	check = undefined
	check = false
	((a) ->
		if /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) or /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
			check = true
		return
	) navigator.userAgent or navigator.vendor or window.opera
	check

$ = jQuery;

$(document).ready ->


	body = $('body')

	#arruma a primeira aba caso seja mobile
	checkDevice = ->
		body.removeClass('is-mobile').removeClass('is-desktop')
		if isMobile()
			body.addClass 'is-mobile'
		else
			body.addClass 'is-desktop'
		return

	checkDevice()
	$(window).on 'load resize', checkDevice

	toggleMenuMobile = ->
		body.toggleClass 'open-menu-mobile'

		if body.is('.open-menu-mobile')
			body.on 'touchmove', false
		else
			body.off 'touchmove', false

		return

	#Abre o menu mobile
	$('.toggle-menu-mobile').on 'click tap', toggleMenuMobile

	checkScroll = ->
		if $(this).scrollTop() > 20
			if !body.is('.scrolled')
				body.addClass('scrolled')
		else
			if body.is('.scrolled')
				body.removeClass('scrolled')
		return

	$(document).on 'scroll', checkScroll

	$(window).on 'load', checkScroll

	$('.menu-item a').on 'click tap', ->
		parent = $(this).parent()
		if $(this).attr('href') == '#' && !isMobile()
			return false
		if parent.is('.menu-item-has-children')
			if isMobile()
				$(this).next('.sub-menu').slideToggle(200);
				parent.toggleClass('opened');
				return false
		return

	$('.button-read-more').on 'click tap', ->
		$(this).prev('.text-read-more').addClass 'show-full-text'
		$(this).hide()
		return

	#Sliders
	$('#curadores-carousel').owlCarousel
		items: 2
		margin: 20
		stagePadding: 20
		loop: true
		nav: true
		dots: false
		navText: [
			'Anterior'
			'Próximo'
		]
		responsive:
			414:
				margin: 30
				stagePadding: 30
			768:
				items: 4
				margin: 30
				stagePadding: 30
				mouseDrag: false
				touchDrag: false
			1024:
				items: 4
				margin: 0
				stagePadding: 0
				mouseDrag: false
				touchDrag: false

	$('#destaques-carousel').owlCarousel
		items: 1
		margin: 20
		stagePadding: 20
		loop: true
		nav: true
		dots: false
		navText: [
			'Anterior'
			'Próximo'
		]
		responsive:
			768:
				items: 2
				stagePadding: 60
			1024:
				items: 3
				stagePadding: 60
			1920:
				items: 3
				margin: 30
				stagePadding: 240
				mouseDrag: false
				touchDrag: false
			2560:
				items: 5
				margin: 30
				stagePadding: 240
				mouseDrag: false
				touchDrag: false

	if viewport().width < 768
		$('#call-carousel').owlCarousel
			items: 1
			margin: 20
			stagePadding: 60
			loop: true

	if viewport().width < 1024
		$('.realizacao-carousel').owlCarousel
			items: 1
			margin: 20
			stagePadding: 20
			responsive:
				414:
					items: 2
					margin: 40
				768:
					items: 4
					margin: 40

	#$(window).on 'load', ->
	pagePositions = []
	pagePositionsID = []
	$('section').each (i, item) ->
		pageId = $(item).attr('id').replace('#','')
		className = pageId + '-active'
		itemHeight = $(item).height()
		itemMidHeight = itemHeight / 2
		pageOffsetInit = $(item).position().top - itemMidHeight
		pageOffsetEnd = pageOffsetInit + itemMidHeight + itemHeight
		scrollTop = $(window).scrollTop()

		if scrollTop >= pageOffsetInit
			if !body.is('.' + className)
					body.addClass(className)
		###if scrollTop > pageOffsetEnd
			if body.is('.' + className)
				body.removeClass(className)###

		$(window).on 'scroll', ->
			scrollTop = $(this).scrollTop()
			if scrollTop >= pageOffsetInit
				if !body.is('.' + className)
					body.addClass(className)
			
			###if scrollTop > pageOffsetEnd
				if body.is('.' + className)
					body.removeClass(className)###
			return
		return

	#Menu Navigation
	if body.is('.page-home')
		$('a[href^="/#"]').on 'click tap', (e) ->
			pageId = $(this).attr('href').replace('/','')
			pageOffset = $(pageId).position().top
			$('body, html').stop().animate
				scrollTop: pageOffset
			, 1000
			toggleMenuMobile()
			e.preventDefault()
			return


	#compartilhar
	$('#social-share > a').on 'click tap', (e) ->
		url = $(this).attr('href')
		wWidth = 600
		wHeight = 400
		leftPos = viewport().width / 2 - (wWidth / 2)
		topPos = viewport().height / 2 - (wHeight / 2)
		options = 'top=' + topPos + ',left=' + leftPos + ',location=0,status=0,scrollbars=1,menubar=0,resizable=1,toolbar=0,width=' + wWidth + ',height=' + wHeight
		window.open url, 'share-window', options
		false
		
	#Não remover esse return
	return